import React from 'react';
import { IconType } from 'react-icons';
import {
  FaArrowRight, FaBoxes, FaChartLine, FaCheck, FaCloud, FaDatabase, FaEnvelope, FaHeadset,
  FaMapMarkerAlt, FaMobileAlt, FaMoneyBillWave, FaPhoneAlt, FaPrint, FaShoppingCart, FaSlidersH,
  FaTags, FaUsers, FaWhatsapp
} from 'react-icons/fa';

import {
  Pagina, Conteudo, Header, Marca, Nav, BotaoRota, BotaoExterno, GrupoBotoes, Hero, Selo, ListaChecks,
  Previa, Secao, Rotulo, TituloSecao, TextoSecao, GradeCards, CardSolucao, Icone, GradeDetalhes, Detalhe,
  Empresa, Numeros, CardContato, Chamada, Rodape, WhatsappFlutuante, BarraMobile
} from './styles';
import {
  CIDADE, EMAIL, ENDERECO, LINK_TELEFONE, LINK_WHATSAPP, LOGO, SITE, TELEFONE
} from '../../constants/contato';
import tifirelogo from '../../assets/images/tifire.ico';

interface ISolucao {
  icone: IconType;
  titulo: string;
  descricao: string;
  itens: string[];
}

interface IDetalhe {
  icone: IconType;
  titulo: string;
  descricao: string;
}

const ROTA_ACESSO = '/acessar';

const solucoes: ISolucao[] = [
  {
    icone: FaShoppingCart,
    titulo: 'Vendas e pedidos',
    descricao: 'Lance vendas e pedidos de qualquer lugar, com o estoque conferido na hora.',
    itens: ['Itens com preço da tabela', 'Desconto, juros e frete', 'Controle de estoque negativo']
  },
  {
    icone: FaBoxes,
    titulo: 'Compras e estoque',
    descricao: 'Registre as compras e acompanhe o saldo de cada produto por depósito.',
    itens: ['Entrada que soma no estoque', 'Estoque por depósito', 'Grade de cor e tamanho']
  },
  {
    icone: FaTags,
    titulo: 'Cadastros',
    descricao: 'Produtos, clientes e fornecedores no mesmo cadastro usado pelo ERP Sigepe.',
    itens: ['Fotos dos produtos', 'Busca de endereço pelo CEP', 'Referência sugerida no produto novo']
  },
  {
    icone: FaMoneyBillWave,
    titulo: 'Financeiro',
    descricao: 'Fluxo de caixa com contas a pagar e a receber, cheques, cartões e saldos por conta.',
    itens: ['Saldo projetado por dia', 'Recebimentos por forma de pagamento', 'Cheques das vendas']
  },
  {
    icone: FaPrint,
    titulo: 'Relatórios',
    descricao: 'Os relatórios do ERP no navegador, com filtros e prontos para imprimir.',
    itens: ['Relatório de vendas', 'Totais por vendedor e comissão', 'Custo e lucro por venda']
  },
  {
    icone: FaChartLine,
    titulo: 'Dashboards gerenciais',
    descricao: 'Indicadores e gráficos da empresa na tela inicial e no app T.I Fire Gerencial.',
    itens: ['Ticket médio e vendas por dia', 'Ranking de vendedores e clientes', 'Também no celular, pelo app']
  }
];

const detalhes: IDetalhe[] = [
  { icone: FaCloud, titulo: 'Direto no navegador', descricao: 'Nada para instalar: acesse do escritório, da loja ou de casa.' },
  { icone: FaMobileAlt, titulo: 'Feito também para o celular', descricao: 'Telas que se ajustam ao tamanho da tela, com toque confortável.' },
  { icone: FaDatabase, titulo: 'Integrado ao ERP Sigepe', descricao: 'Usa o mesmo banco de dados do sistema desktop, sem importar nem exportar.' },
  { icone: FaUsers, titulo: 'Multiempresa e filiais', descricao: 'Cada filial com seu próprio acesso, escolhida já na entrada.' },
  { icone: FaSlidersH, titulo: 'Telas configuráveis', descricao: 'Campos, rótulos, menus e atalhos ajustados para a sua operação.' },
  { icone: FaHeadset, titulo: 'Suporte de quem fez o sistema', descricao: 'Implantação, treinamento e atendimento direto com a equipe TI.Fire.' }
];

export default function Home() {
  const ano = new Date().getFullYear();

  return (
    <Pagina>
      <Header>
        <Conteudo>
          <Marca href='#inicio'>
            <img src={LOGO} alt='' />
            <strong>SigepeWeb</strong>
            <span>por TI.Fire Sistemas</span>
          </Marca>
          <Nav aria-label='Seções da página'>
            <a className='ancora' href='#solucoes'>Soluções</a>
            <a className='ancora' href='#detalhes'>Detalhes</a>
            <a className='ancora' href='#empresa'>Empresa</a>
            <a className='ancora' href='#contato'>Contato</a>
            <BotaoRota to={ROTA_ACESSO} $variante='accent' $pequeno>
              Acessar plataforma
            </BotaoRota>
          </Nav>
        </Conteudo>
      </Header>

      <main id='inicio'>
        <Hero>
          <Conteudo>
            <div>
              <Selo>ERP Web da TI.Fire Sistemas</Selo>
              <h1>Sua empresa no <em>Sigepe</em>, de qualquer lugar.</h1>
              <p className='descricao'>
                O SigepeWeb leva vendas, compras, estoque, financeiro, relatórios e dashboards
                do ERP Sigepe para o navegador e o celular, com os mesmos dados do sistema que você já usa.
              </p>
              <GrupoBotoes>
                <BotaoRota to={ROTA_ACESSO} $variante='accent'>
                  Acessar plataforma
                  <FaArrowRight aria-hidden />
                </BotaoRota>
                <BotaoExterno href={LINK_WHATSAPP} target='_blank' rel='noreferrer' $variante='whatsapp'>
                  <FaWhatsapp aria-hidden />
                  Falar no WhatsApp
                </BotaoExterno>
              </GrupoBotoes>
              <ListaChecks $inverso>
                {['Sem instalação', 'Mesmo banco do ERP desktop', 'Acesso por empresa e filial'].map(item => (
                  <li key={item}><FaCheck aria-hidden />{item}</li>
                ))}
              </ListaChecks>
            </div>

            <Previa aria-hidden>
              <div className='barra'><i />Início · Vendas do mês</div>
              <div className='corpo'>
                <div className='kpis'>
                  <div className='kpi'><small>Vendas</small><strong>R$ 84,2 mil</strong></div>
                  <div className='kpi'><small>Ticket médio</small><strong>R$ 312</strong></div>
                  <div className='kpi'><small>Qtde</small><strong>270</strong></div>
                </div>
                <div className='grafico'>
                  <small>Vendas por dia</small>
                  <div className='barras'>
                    {[42, 60, 35, 75, 52, 88, 64, 47, 70, 95, 58, 80].map((altura, i) => (
                      <span key={i} style={{ height: `${altura}%` }} />
                    ))}
                  </div>
                </div>
              </div>
            </Previa>
          </Conteudo>
        </Hero>

        <Secao id='solucoes'>
          <Conteudo>
            <Rotulo>Soluções</Rotulo>
            <TituloSecao>Do pedido ao caixa, a gestão inteira em uma plataforma.</TituloSecao>
            <TextoSecao>
              Os módulos do SigepeWeb trabalham sobre os mesmos cadastros e movimentos do ERP Sigepe.
              O que é lançado na web aparece no desktop, e vice-versa.
            </TextoSecao>
            <GradeCards>
              {solucoes.map(({ icone: IconeSolucao, titulo, descricao, itens }) => (
                <CardSolucao key={titulo}>
                  <Icone><IconeSolucao aria-hidden /></Icone>
                  <h3>{titulo}</h3>
                  <p>{descricao}</p>
                  <ul>
                    {itens.map(item => <li key={item}><FaCheck aria-hidden />{item}</li>)}
                  </ul>
                </CardSolucao>
              ))}
            </GradeCards>
          </Conteudo>
        </Secao>

        <Secao id='detalhes' $fundo='surface'>
          <Conteudo>
            <Rotulo>Detalhes</Rotulo>
            <TituloSecao>Pensado para o dia a dia de quem usa o Sigepe.</TituloSecao>
            <GradeDetalhes>
              {detalhes.map(({ icone: IconeDetalhe, titulo, descricao }) => (
                <Detalhe key={titulo}>
                  <Icone $suave><IconeDetalhe aria-hidden /></Icone>
                  <div>
                    <h3>{titulo}</h3>
                    <p>{descricao}</p>
                  </div>
                </Detalhe>
              ))}
            </GradeDetalhes>
          </Conteudo>
        </Secao>

        <Secao id='empresa'>
          <Conteudo>
            <Empresa>
              <div>
                <Rotulo>Empresa</Rotulo>
                <TituloSecao>TI.Fire Sistemas e Consultoria</TituloSecao>
                <TextoSecao>
                  Somos de {CIDADE} e desenvolvemos o ERP Sigepe, usado por empresas do comércio, da
                  indústria e de serviços. Além do sistema desktop, criamos o SigepeWeb, aplicativos de
                  venda e o app T.I Fire Gerencial, todos ligados ao mesmo banco de dados.
                </TextoSecao>
                <TextoSecao>
                  Cuidamos da implantação, do treinamento e do suporte, com atendimento direto pelo
                  WhatsApp e telefone.
                </TextoSecao>
              </div>
              <Numeros>
                <div><dt>Sede</dt><dd>{CIDADE}</dd></div>
                <div><dt>Produto</dt><dd>ERP Sigepe</dd></div>
                <div><dt>Plataformas</dt><dd>Desktop, Web e App</dd></div>
                <div><dt>Suporte</dt><dd>{TELEFONE}</dd></div>
              </Numeros>
            </Empresa>
          </Conteudo>
        </Secao>

        <Secao id='contato' $fundo='surface'>
          <Conteudo>
            <Rotulo>Contato</Rotulo>
            <TituloSecao>Fale com a gente.</TituloSecao>
            <TextoSecao>Tire dúvidas, peça uma demonstração ou chame o suporte.</TextoSecao>
            <GradeCards>
              <CardContato href={LINK_WHATSAPP} target='_blank' rel='noreferrer'>
                <Icone><FaWhatsapp aria-hidden /></Icone>
                <div><small>WhatsApp</small><strong>{TELEFONE}</strong></div>
              </CardContato>
              <CardContato href={LINK_TELEFONE}>
                <Icone><FaPhoneAlt aria-hidden /></Icone>
                <div><small>Telefone</small><strong>{TELEFONE}</strong></div>
              </CardContato>
              <CardContato href={`mailto:${EMAIL}`}>
                <Icone><FaEnvelope aria-hidden /></Icone>
                <div><small>E-mail</small><strong>{EMAIL}</strong></div>
              </CardContato>
              <CardContato
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${ENDERECO}, ${CIDADE}`)}`}
                target='_blank'
                rel='noreferrer'
              >
                <Icone><FaMapMarkerAlt aria-hidden /></Icone>
                <div><small>Endereço</small><strong>{ENDERECO} - {CIDADE}</strong></div>
              </CardContato>
            </GradeCards>

            <Chamada>
              <h2>Já é cliente? Entre com o CNPJ da sua empresa.</h2>
              <p>Ainda não usa o SigepeWeb? Chame no WhatsApp e veja o sistema funcionando.</p>
              <GrupoBotoes $centro>
                <BotaoRota to={ROTA_ACESSO} $variante='accent'>
                  Acessar plataforma
                  <FaArrowRight aria-hidden />
                </BotaoRota>
                <BotaoExterno href={LINK_WHATSAPP} target='_blank' rel='noreferrer' $variante='whatsapp'>
                  <FaWhatsapp aria-hidden />
                  Falar no WhatsApp
                </BotaoExterno>
              </GrupoBotoes>
            </Chamada>
          </Conteudo>
        </Secao>
      </main>

      <Rodape>
        <Conteudo>
          <a href={SITE} target='_blank' rel='noreferrer'>
            <img src={tifirelogo} alt='' />
            TI.Fire Sistemas e Consultoria
          </a>
          <span>© {ano} SigepeWeb · {CIDADE}</span>
        </Conteudo>
      </Rodape>

      <WhatsappFlutuante href={LINK_WHATSAPP} target='_blank' rel='noreferrer' aria-label='Falar no WhatsApp'>
        <FaWhatsapp aria-hidden />
      </WhatsappFlutuante>

      <BarraMobile>
        <BotaoExterno href={LINK_WHATSAPP} target='_blank' rel='noreferrer' $variante='whatsapp' aria-label='Falar no WhatsApp'>
          <FaWhatsapp aria-hidden />
        </BotaoExterno>
        <BotaoRota to={ROTA_ACESSO} $variante='primario'>
          Acessar plataforma
        </BotaoRota>
      </BarraMobile>
    </Pagina>
  );
}
